import { useQuery } from 'react-query';

import { Inconsistency } from '../../../../backend/src/case/inconsistency/inconsistency.entity';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface InconsistencyReportGetAllResponse {
  title: string;
  inconsistencies: Inconsistency[];
}

export const useGetAllInconsistencyReportItems = ({ caseId, reportId }: { caseId: string; reportId: string }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<InconsistencyReportGetAllResponse>(
    [QueryEntity.InconsistencyReport, { reportId }, 'all'],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/inconsistency-report/${reportId}/all`,
        fetchConfigGET,
      );

      return res.json();
    },
    { refetchOnWindowFocus: false },
  );
};
